//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import { importf } from "./util/index.js";
export default {
  name: "",
  mounted() {},
  methods: {
    refresh() {
      const loading = this.$loading();
      axios.defaults.headers = {
        Authorization: sessionStorage.getItem("Authorization")
      };
      let formTmp = new FormData();
      formTmp.append("type", "manage");
      axios.post(this.$apiUrl, formTmp).then(data => {
        loading.close();
        this.$store.commit("changePromsg", JSON.parse(data.data.msg));
        if (data.data.success == false) {
          this.$message.error(data.data.msg);
          this.$router.push("/login");
        }
      });
    },
    getMsg(data) {
      // console.log(data)
      importf(data.srcElement);
      // console.log(data.srcElement)
    },
    showModel() {
      this.$store.commit("changeIsShow", true);
    },
    hideModel() {
      this.$store.commit("changeIsShow", false);
    },
    postMsg() {
      if (this.title != "") {
        const loading = this.$loading();
        this.$store.commit("changeIsShow", false);
        let msg = {
          title: this.title,
          copyright: this.copyright,
          radio: this.radio,
          time: (new Date().getTime() / 1000).toFixed(0),
          source: this.$store.state.SheetBox[0],
          keys: this.$store.state.keys
        };
        let formTmp = new FormData();
        formTmp.append("type", "newMsg");
        formTmp.append("title", this.title);
        formTmp.append("num", this.$store.state.SheetBox[0].length);
        formTmp.append("time", (new Date().getTime() / 1000).toFixed(0));
        formTmp.append("source", JSON.stringify(msg));
        axios.defaults.headers = {
          Authorization: sessionStorage.getItem("Authorization")
        };
        axios.post(this.$apiUrl, formTmp).then(data => {
          loading.close();
          // console.log(data.data);
          if (data.data.success == true) {
            this.refresh();
            this.$store.commit("changeKeys", []);
            this.$store.commit("changeSheetBox", []);
            this.title = null;
          }
        });
      } else {
        this.$notify({
          title: "警告",
          message: "请输入标题",
          type: "warning"
        });
      }
      // console.log(msg);
    },
    deleteMsg(time) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          axios.defaults.headers = {
            Authorization: sessionStorage.getItem("Authorization")
          };
          let formTmp = new FormData();
          formTmp.append("type", "deleteMsg");
          formTmp.append("time", time);
          const loading = this.$loading();
          axios.post(this.$apiUrl, formTmp).then(data => {
            // console.log(data.data)
            loading.close();
            if (data.data.success == true) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.refresh();
            }
          });
        })
        .catch(() => {});
    },
    showDetail(index) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.box.title = this.$store.state.proMsg[index].title;
      this.box.domain = location.href.replace(
        "/manage/dataQuery",
        "/m/" + this.$store.state.proMsg[index].time
      );
      let formTmp = new FormData();
      formTmp.append("type", "getMsg");
      formTmp.append("time", this.$store.state.proMsg[index].time);
      axios.post(this.$apiUrl, formTmp).then(data => {
        loading.close();
        this.centerDialogVisible = true;
        this.box.keys = data.data.msg.keys;
        this.box.source = data.data.msg.source;
      });
    }
  },
  data() {
    return {
      title: "",
      copyright: "",
      radio: "0",
      box: {
        title: "",
        source: [],
        domain: "",
        keys: []
      },
      centerDialogVisible: false,
      bgImg: [
        {
          title: 1,
          url:
            "https://wx1.sinaimg.cn/large/006WWHDcgy1fy8r3zuebmg309l0byq2r.gif"
        },
        {
          title: 2,
          url:
            "https://wx3.sinaimg.cn/large/006WWHDcgy1fy8r575c4dg309l0byq2r.gif"
        },
        {
          title: 3,
          url:
            "https://ws2.sinaimg.cn/large/006WWHDcgy1fy8r5zvl99g309l0byq2r.gif"
        },
        {
          title: 4,
          url:
            "https://wx1.sinaimg.cn/large/006WWHDcgy1fy8r6ar85xg309l0byq2r.gif"
        },
        {
          title: 5,
          url:
            "https://wx4.sinaimg.cn/large/006WWHDcgy1fy8r768jgtg309l0byq2r.gif"
        }
      ]
    };
  }
};



// WEBPACK FOOTER //
// ./src/components/Content.vue